/* eslint-disable import/prefer-default-export */
import { httpRequest } from 'utils';
import { errorDispatcher } from './actionUtils';

export const fetchAppSettings = async (dispatch) => {
  const response = await httpRequest('/appSettings', 'get', null, null)
    .catch(() => errorDispatcher(dispatch, "We're having some network issues right now, please reload the page to try again."));
  return response;
};
